import { emojis } from '../emojis'
import { theme } from '../theme'

export const getColorByEmoji = (emoji: typeof emojis[number]) => {
  switch (emoji) {
    case '🍊':
    case '🔥':
    case '🦧':
      return theme.color.amber[300]
    case '🍌':
    case '🐱':
    case '😊':
    case '🥺':
      return theme.color.amber[100]
    case '🍓':
    case '🏠':
    case '🏳️‍🌈':
    case '🚀':
      return theme.color.red[100]
    case '🧊':
    case '🧢':
      return theme.color.blue[100]
    case '👻':
    case '💀':
      return theme.color.gray[100]
    default:
      return theme.color.gray[100]
  }
}